module.exports = __webpack_public_path__ + "2d297c20569f78e56f65617da7ff0349.svg";